import {
  colors,
  displayFlexAlignItemsCenterJustifyContentCenter,
  displayFlexAlignItemsCenterJustifyContentSpaceBetween,
  tokens
} from '../../styles';
// import PropTypes from "prop-types";
import { Input } from '@mui/material';
import Box from '@mui/material/Box';

const TextField = ({
  placeholder,
  onChange,
  style,
  startIcon,
  endIcon,
  type = 'text',
  value = '',
  name,
  bgColor = colors.text31,
  multiline = false,
  rows = 1,
  required = false,
  inputProps = {}
}) => {
  return (
    <Box
      borderRadius='10px'
      bgcolor={bgColor}
      padding='15px'
      height={'60px'}
      sx={{ ...style, ...displayFlexAlignItemsCenterJustifyContentCenter }}
    >
      <Box width='100%'>
        <Box
          {...displayFlexAlignItemsCenterJustifyContentSpaceBetween}
          alignItems={'center'}
        >
          {startIcon && (
            <Box
              width={'10%'}
              {...displayFlexAlignItemsCenterJustifyContentCenter}
              mr={'10px'}
            >
              {startIcon}
            </Box>
          )}
          <Input
            fullWidth
            disableUnderline
            style={tokens.FS18FW500LH21_6M}
            type={type}
            name={name}
            onChange={onChange}
            value={value}
            multiline={multiline}
            required={required}
            rows={rows}
            inputProps={inputProps}
            sx={{
              color: colors.whiteFF,
              '& input': {
                padding: 0
              },
              '& .MuiInput-input::-webkit-scrollbar': {
                display: 'none'
              }
            }}
            placeholder={placeholder}
          />
          {endIcon && (
            <Box
              width={'10%'}
              ml={'10px'}
              {...displayFlexAlignItemsCenterJustifyContentCenter}
            >
              {endIcon}
              {/* <Image src={"/icons/mail.svg"} alt="mail" height={20} width={20} /> */}
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

// TextField.PropTypes = {
//   placeholder: PropTypes.string.isRequired,
//   onChange: PropTypes.func.isRequired,
//   style: PropTypes.object,
//   startIcon: PropTypes.element,
//   endIcon: PropTypes.element,
//   type: PropTypes.oneOf(["text", "email", "password"]),
// };

export default TextField;
